import { useNavigate } from "react-router-dom";
import MainLayout from "@/components/layout/MainLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function StrategyForm() {
  const navigate = useNavigate();

  const handleStartForm = () => {
    window.location.href = "https://wealthysteward.com/intake-form?v=2";
  };

  return (
    <MainLayout>
      <div className="max-w-6xl mx-auto p-6">
        <Card>
          <CardHeader>
            <CardTitle className="text-2xl">UNA Strategy Intake Form</CardTitle>
            <CardDescription>
              Please complete the form below to help us understand your goals and current situation.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="space-y-4">
              <p className="text-muted-foreground">
                You'll be taken to the strategy intake form. After you submit it, you'll be automatically redirected back to this app.
              </p>
              
              <Button 
                onClick={handleStartForm}
                size="lg"
                className="w-full"
              >
                Start the Strategy Intake
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </div>
            
            {/* Fallback link */}
            <div className="text-center pt-4 border-t">
              <p className="text-xs text-muted-foreground mb-2">
                Already submitted and got stuck?
              </p>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => navigate('/strategy-complete')}
              >
                Click here to continue
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
}
